<template>
  <div style="margin: 0 24px 12px;">
    <el-form ref="formRef" :model="medicalForm" label-width="90px" label-position="right">
      <el-form-item label="门店：">
        <el-select v-model="shopId" placeholder="请选择" style="width: 34em">
          <el-option v-for="item in shopIdArr" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="medicalForm.type > 0?'赠送金额：':'扣除金额：'">
        <el-input v-model="medicalForm.money" placeholder="请输入医疗金金额" style="width: 34em" />
        <span style="color: red; font-size: 12px;">*不允许输入负数</span>
      </el-form-item>

      <el-form-item label="图片凭证：">
        <el-space wrap>
          <div class="img-box" v-for="(item, index) in imgArray" :key="item.id">
            <el-image style="width: 80px; height: 80px;" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            <div class="delIcon" @click="delImg(index)"><ElIcons name="CloseBold" color="#ffffff"/></div>
          </div>
          <div class="add" @click="fileUpdate" v-if="imgArray.length < routeImageNum">
            <span>+</span>
          </div>
        </el-space>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">
      </el-form-item>

      <el-form-item label="备注：">
        <el-input v-model="medicalForm.remark" type="textarea" :rows="6" placeholder="非必填" style="width: 34em" />
      </el-form-item>

    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import {addOrUpdateMedicalDetail, delMedicalDetailImg} from "@/api/url";
import {moneyReg} from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      loading: false,
      medicalForm: JSON.parse(this.value.medicalForm),
      idx: this.value.ids,
      userId: this.value.userId,
      shopIdArr: [],
      shopId: '',
      imgArray: [],
      routeImageNum: 9,
      delImgIdArray: []
    }
  },
  methods: {


    // 删除图片
    delImg(idx) {
      if(this.imgArray[idx].id > 0) {
        postFormData(delMedicalDetailImg, {id: this.imgArray[idx].id}).then(data => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.imgArray.splice(idx,1);
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
        })
      }else {
        this.imgArray.splice(idx,1);
      }
    },

    //更改或添加
    fileUpdate() {
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item};
          this.imgArray.push(obj);
        }
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.shopId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择门店',
          type: 'warning'
        });
        return false
      }
      // if(!this.medicalForm.money) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '医疗金金额不能为空',
      //     type: 'warning'
      //   });
      //   return false
      // }
      if(!moneyReg.test(this.medicalForm.money)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的医疗金金额',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      param.append('id', this.idx > -1?this.medicalForm.id:0);
      param.append('userId', this.userId);
      param.append('shopId', this.shopId);
      param.append('type', this.medicalForm.type);
      param.append('money', this.medicalForm.money);
      param.append('remark', this.medicalForm.remark?this.medicalForm.remark:'');
      for(let i = 0; i < this.imgArray.length; i++) {
        if(!this.imgArray[i].id) {
          param.append('file' + i, this.imgArray[i].files);
        }
      }
      imgPostFormData(addOrUpdateMedicalDetail, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', data.data)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    },


  },
  mounted() {
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArr = this.shopIdArr.concat(ownShopList)
    if(this.idx > -1) {
      this.shopId = this.medicalForm.shopId
      this.imgArray = this.medicalForm.imgList
    }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
